import { useQuery } from '@tanstack/react-query'
import { Organisations } from '../../types'
import { apiClient } from '../../client'
import { handleApiQuery } from '@reapit-sales/utilities'
import { useSnack } from '@reapit/elements'

/**
 * GET RS v1 /organisations: useGetOrganisations
 */
export const useGetOrganisations = (headers?: Record<string, string>, enabled: boolean = true) => {
  return useQuery<Organisations>({
    queryKey: ['organisations'],
    queryFn: handleApiQuery(useSnack())(async () => {
      const response = await apiClient.get<Organisations>('/organisations', {
        headers,
      })
      return response.data
    }),
    enabled,
    refetchOnWindowFocus: false,
  })
}
